module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ScoreView.js"));
	}, "ScoreView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ScoreView!./src/pages/Learn/My/Score/ScoreView.js
// module id = 1748
// module chunks = 418